import React from 'react';
import { css } from 'linaria';
import { styled } from 'linaria/react';

export const servicePanelGroupName = css`
  padding: 7px 0;

  @media (--only-largeDesktop) {
    white-space: break-spaces;
  }

  @media (--only-mobile) {
    z-index: 2;
    padding: 8px 0;
  }
`;

export const PanelHeader = styled.div`
  @media (--from-tablet) {
    user-select: none;
  }

  @media (--only-mobile) {
    position: relative;
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 20px 0;
    cursor: pointer;
    transition: all 0.5s ease;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100vw - 16px);
      height: 1px;
      background-color: var(--control-minor);
      content: '';
    }

    &:active::after {
      position: absolute;
      top: 0;
      left: -16px;
      width: 100vw;
      height: 100%;
      background-color: var(--background-secondary);
      content: '';
    }
  }
`;

export const openServicePanelHeader = css`
  && {
    @media (--only-mobile) {
      padding-bottom: 4px;
    }
  }
`;

export const servicePanelIcon = css`
  @media (--only-mobile) {
    z-index: 2;
  }
`;

export const panelArrowIcon = css`
  @media (--from-tablet) {
    display: none;
  }

  z-index: 2;
  margin: 8px 0;
  margin-left: auto;
  transition: all 0.5s ease;
`;

export const openPanelArrowIcon = css`
  transform: rotate(-180deg);
`;

type ServicePanelBodyProps = {
  height: string;
  isOpen: boolean;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const ServicePanelBody = styled.div<ServicePanelBodyProps>`
  height: 100%;

  @media (--only-mobile) {
    height: ${({ height }: ServicePanelBodyProps) => height};
    overflow: hidden;
    transform: rotate(0.01deg);
    transition: all 0.5s ease;
    transition: all 0.5s ease;
    transition: all 0.5s ease;
  }
`;
